import { render } from "./AddParametroView.vue?vue&type=template&id=d0f50c88&scoped=true"
import script from "./AddParametroView.vue?vue&type=script&lang=js"
export * from "./AddParametroView.vue?vue&type=script&lang=js"

import "./AddParametroView.vue?vue&type=style&index=0&id=d0f50c88&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0f50c88"]])

export default __exports__